import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "4468d727-0801-4f60-acd1-2ffe6156d3bb",
    content: "Cochlea",
    options: {},
  },
  {
    id: "39f6ef84-8d3e-46e6-92c6-ff30437eff05",
    content: "Tympanic membrane",
    options: {},
  },
  {
    id: "fcea70c1-d4fe-4c82-a0c2-a17d5305420d",
    content: "Earlobe",
    options: {},
  },
  {
    id: "705c78ff-8ac4-4a81-ba4d-8bd658249646",
    content: "Organ of Corti",
    options: {},
  },
];

const groups = [
  {
    id: "375de091-24e0-4bfc-b330-130fcca83e77",
    options: {
      imageUrl: `${config.ASSETS_URL}/02/01/task/01/cochlea.svg`,
    },
  },
  {
    id: "48f453cc-f41b-4531-9c6a-8bc3fe88f6f7",
    options: {
      imageUrl: `${config.ASSETS_URL}/02/01/task/01/tympanic-membrane.svg`,
    },
  },
  {
    id: "ed5f7bb3-6edb-4e4d-98c7-2cc20d439d42",
    options: {
      imageUrl: `${config.ASSETS_URL}/02/01/task/01/earlobe.svg`,
    },
  },
  {
    id: "054ce5e9-d26c-43ea-b733-373be305c800",
    options: {
      imageUrl: `${config.ASSETS_URL}/02/01/task/01/organ-of-corti.svg`,
    },
  },
];

export const task: Task = {
  id: "83035777-6636-489d-929e-00a8d7fdcd67",
  solutionType: "order",
  type: "orderLabels",
  options: {
    orientation: "horizontal-reverse",
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "4468d727-0801-4f60-acd1-2ffe6156d3bb",
    "39f6ef84-8d3e-46e6-92c6-ff30437eff05",
    "fcea70c1-d4fe-4c82-a0c2-a17d5305420d",
    "705c78ff-8ac4-4a81-ba4d-8bd658249646",
  ],
};
